export const LEAD_DETAILS_OVERLAYS = {
    BUCKET_HISTORY: 'bucketHistory',
    CONSORS_NOTES: 'consorsNotes',
    CREATE_APPLICANT: 'createApplicant',
    CREATE_OFFER: 'createOffer',
    CREDIT_WORTHINESS_ID: 'creditWorthinessId',
    DUPLICATES: 'duplicates',
    EDIT_OFFER_ID: 'editOfferId',
    EUROPACE_EVENTS: 'europaceEvents',
    FORM_LOANS: 'formLoans',
    LEGAL_CONSENT: 'legalConsent',
    OFFER_EXTRA_INFO_ID: 'offerExtraInfoId',
    OFFER_INFO_ID: 'offerInfoId',
    PARTNER: 'partner',
    SCHUFA: 'schufa',
    TRACKING_UTM: 'trackingUtm',
} as const;
